#import "../fragments/meeting-fragment.graphql"

query GetMeeting($id: ID!) {
    meeting(id: $id) {
        ...MeetingFragment
    }
}
